import React from 'react';
import { FiCheck, FiZoomIn } from 'react-icons/fi';

const ImageOptionCard = ({
	option,
	fieldKey,
	isSelected,
	variant = 'radio',
	onImageClick,
	children,
}) => {
	const optionValue = option.value || option;
	const optionLabel = option.label || option;
	const imageUrl = option.imageUrl;
	const isRadio = variant === 'radio';

	return (
		<label
			key={optionValue}
			htmlFor={`${fieldKey}-${optionValue}`}
			className={`group relative rounded-lg border cursor-pointer overflow-hidden transition-all duration-300 ease-in-out
				${isSelected
					? 'border-black ring-1 ring-black/5 scale-[1.01]'
					: 'border-gray-200 bg-white hover:border-gray-400 active:scale-[0.98]'
				}
			`}
		>
			{children}
			{imageUrl && (
				<div className='relative aspect-[3/2] overflow-hidden bg-gray-50'>
					<img
						src={imageUrl}
						alt={optionLabel}
						className={`w-full h-full object-cover object-top transition-all duration-500 ease-out group-hover:scale-[1.03] ${isSelected ? 'grayscale-0 brightness-105' : 'grayscale-[20%] group-hover:grayscale-0'}`}
						loading='lazy'
					/>
					{/* Zoom icon for image preview - only this button opens the preview */}
					{onImageClick && (
						<button
							type='button'
							className='absolute top-2 right-2 p-1.5 bg-black/50 hover:bg-black/70 rounded-full text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 cursor-zoom-in'
							onClick={(e) => { e.preventDefault(); e.stopPropagation(); onImageClick({ src: imageUrl, alt: optionLabel }); }}
							aria-label={`View full image for ${optionLabel}`}
							onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onImageClick({ src: imageUrl, alt: optionLabel }); } }}
						>
							<FiZoomIn className='w-3.5 h-3.5' />
						</button>
					)}
				</div>
			)}
			<div className='p-4 flex items-center'>
				<div className={`flex-shrink-0 w-4 h-4 ${isRadio ? 'rounded-full' : 'rounded-sm'} border-2 mr-3 flex items-center justify-center transition-all duration-200
					${isSelected ? 'border-gray-900 bg-gray-900' : 'border-gray-300 bg-white'}
				`}>
					{isSelected && (
						isRadio
							? <div className='w-1.5 h-1.5 rounded-full bg-white' />
							: <FiCheck className='h-2.5 w-2.5 text-white' />
					)}
				</div>
				<span className={`font-montserrat-regular text-xs uppercase tracking-wider ${isSelected ? 'text-black font-montserrat-medium' : 'text-gray-600'}`}>
					{optionLabel}
				</span>
			</div>
		</label>
	);
};

export default ImageOptionCard;
